import { Modal, TextArea, Toast } from "@vesatogo/grass-core"

import { useState } from "react"
import toast from "react-hot-toast"

export type RejectModalType = {
  isOpen: boolean
  setOpen: any
  onComplete?: any
  defaultRemark?: string
}

export const RejectModal = ({
  isOpen,
  setOpen,
  onComplete,
  defaultRemark = "",
}: RejectModalType) => {
  const [remark, setRemark] = useState(defaultRemark)

  const onClose = (remark = "") => {
    onComplete?.(remark)
    setOpen(false)
  }
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      bodyClassName="max-w-lg"
      title={defaultRemark ? "Remark" : "Action"}
      primaryActionButtonProps={{
        text: "Save",
        onClick: async () => {
          if (!remark) {
            return toast.custom(
              <Toast title={"Please add a Remark!"} intent="danger" />
            )
          }
          onClose(remark)
        },
        hidden: defaultRemark ? true : false,
      }}
      secondaryActionButtonProps={{
        text: "Cancel",
        onClick: () => onClose(),
        hidden: defaultRemark ? true : false,
      }}
    >
      <TextArea
        label={defaultRemark ? "" : "Remark"}
        placeholder="Type"
        value={remark}
        onChange={(e: any) => {
          setRemark(e?.target?.value)
        }}
        disabled={Boolean(defaultRemark)}
        className="w-full"
      ></TextArea>
    </Modal>
  )
}
